/* Tabs */
$('.tabs__nav-item').click(function() {
    var $this = $(this);
    var tab_id = $(this).attr('data-tab');

    $('.tabs__nav .tabs__nav-item').removeClass('current');
    $('.tabs__content-item').removeClass('current');
    $this.addClass('current');
    $("#" + tab_id).addClass('current');
});